import { useLocation } from "react-router";
import { whatsappUrl } from "../../shared/whatsapp";
import { useI18n } from "../i18n/I18nProvider";
import { useCatalog } from "../lib/CatalogProvider";

/** The WhatsApp logo, in the current text color. */
export function WhatsAppIcon({ size = 20 }: { size?: number }) {
  return (
    <svg viewBox="0 0 32 32" width={size} height={size} aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M16.04 3C8.86 3 3.03 8.82 3.03 16c0 2.3.6 4.54 1.75 6.52L3 29l6.65-1.74A12.95 12.95 0 0 0 16.04 29C23.2 29 29 23.18 29 16S23.2 3 16.04 3Zm0 23.64c-2 0-3.95-.54-5.65-1.55l-.4-.24-3.95 1.03 1.05-3.85-.26-.4A10.6 10.6 0 0 1 5.4 16c0-5.86 4.77-10.63 10.64-10.63 5.86 0 10.62 4.77 10.62 10.63 0 5.87-4.76 10.64-10.62 10.64Zm5.83-7.96c-.32-.16-1.89-.93-2.18-1.04-.29-.1-.5-.16-.72.16-.21.32-.82 1.04-1 1.25-.19.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.59-.95-.85-1.59-1.9-1.78-2.22-.18-.32-.02-.49.14-.65.15-.14.32-.37.48-.56.16-.19.21-.32.32-.53.1-.21.05-.4-.03-.56-.08-.16-.72-1.73-.98-2.37-.26-.62-.52-.54-.72-.55h-.61c-.21 0-.56.08-.85.4-.29.32-1.12 1.09-1.12 2.66 0 1.57 1.14 3.08 1.3 3.3.16.2 2.24 3.42 5.43 4.8.76.33 1.35.52 1.81.67.76.24 1.45.2 2 .12.61-.09 1.89-.77 2.15-1.52.27-.74.27-1.38.19-1.52-.08-.13-.29-.21-.61-.37Z"
      />
    </svg>
  );
}

/**
 * Floating WhatsApp button (bottom right): opens a chat with the shop, the message already says
 * which page the customer was on. Hidden until the number is set (Admin › Pedidos › WhatsApp).
 */
export function WhatsAppBubble() {
  const { t, pick } = useI18n();
  const { settings } = useCatalog();
  const { pathname, search } = useLocation();
  const phone = settings.whatsapp ? pick(settings.whatsapp) : "";
  const page = pathname === "/" ? "" : ` (${window.location.origin}${pathname}${search})`;
  const url = whatsappUrl(phone, `${t("whatsapp.message")}${page}`);
  if (!url) return null;
  return (
    <a className="wa-bubble" href={url} target="_blank" rel="noopener noreferrer" aria-label={t("whatsapp.label")} title={t("whatsapp.label")}>
      <WhatsAppIcon size={30} />
    </a>
  );
}
